import { Inject } from "inversify-props";
import type { GrupoDeClienteServiceAdapter } from "./adapter/GrupoDeClienteServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { GrupoDeCliente, Page } from "@/models";

export class GrupoDeClienteUseCase {
	@Inject('GrupoDeClienteServiceAdapter')
	private grupoDeClienteServiceAdapter!: GrupoDeClienteServiceAdapter

	findPageGrupoDeCliente = async (params?: any, config?: AxiosRequestConfig): Promise<Page<GrupoDeCliente>> =>
		await this.grupoDeClienteServiceAdapter.findPageGrupoDeCliente(params, config)

	criarGrupoDeCliente = async (grupoDeCliente: GrupoDeCliente): Promise<GrupoDeCliente> =>
		await this.grupoDeClienteServiceAdapter.criarGrupoDeCliente(grupoDeCliente)

	atualizarGrupoDeCliente = async (grupoDeCliente: GrupoDeCliente): Promise<GrupoDeCliente> =>
		await this.grupoDeClienteServiceAdapter.atualizarGrupoDeCliente(grupoDeCliente)

	deletarGrupoDeCliente = async (grupoDeClienteId: string): Promise<void> =>
		await this.grupoDeClienteServiceAdapter.deletarGrupoDeCliente(grupoDeClienteId)

	listarGruposDeCliente = async (params?: any, config?: AxiosRequestConfig): Promise<GrupoDeCliente[]> =>
		await this.grupoDeClienteServiceAdapter.listarGruposDeCliente(params, config)

	findGruposVinculadosComCliente = async (params?: any, config?: AxiosRequestConfig): Promise<Page<GrupoDeCliente>> =>
		await this.grupoDeClienteServiceAdapter.findGruposVinculadosComCliente(params, config)

	possuiGrupoDeClienteByGrupoEconomico = async (clienteId: string, grupoId: string): Promise<boolean> =>
		await this.grupoDeClienteServiceAdapter.possuiGrupoDeClienteByGrupoEconomico(clienteId, grupoId)

	vincularGrupoDeCliente = async (clienteId: string, grupoId: string): Promise<void> =>
		await this.grupoDeClienteServiceAdapter.vincularGrupoDeCliente(clienteId, grupoId)

	desvincularGrupoDeCliente = async (grupoId: string, clienteId: string): Promise<void> =>
		await this.grupoDeClienteServiceAdapter.desvincularGrupoDeCliente(grupoId, clienteId)

}